import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class BasedOnEnumTypes extends Entity<BasedOnEnumTypes> {

    @Expose()
    name!: string

}
